export default __webpack_public_path__ + "static/media/institute-20-min.6f40b70f.webp";